/* TOYBOX — panier latéral (options, anti-commande test, minimum), menu mobile, langue. API : SB.add(items) / SB.open() */
(function () {
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('sb-data').textContent); } catch (e) {}
  var T = CFG.t || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(c) {
    var v = (Number(c) || 0) / 100, fmt = CFG.money || '{{amount_with_comma_separator}} €';
    var n2 = function (sepT, sepD) { var p = v.toFixed(2).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepT) + sepD + p[1]; };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return n2('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toString();
      if (k === 'amount_no_decimals') return Math.round(v).toString();
      return n2(',', '.');
    });
  }
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- tiroirs ---------- */
  var lastFocus = null;
  function show(el) { if (!el) return; lastFocus = document.activeElement; el.hidden = false; requestAnimationFrame(function () { el.classList.add('is-open'); }); document.documentElement.classList.add('sb-lock'); var f = el.querySelector('button, a, select'); if (f) f.focus({ preventScroll: true }); }
  function hide(el) { if (!el || el.hidden) return; el.classList.remove('is-open'); setTimeout(function () { el.hidden = true; }, 260); document.documentElement.classList.remove('sb-lock'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }

  var cartEl = $('[data-sb-cart]'), drawer = $('[data-sb-drawer]'), burger = $('[data-sb-menu]');

  /* ---------- panier ---------- */
  var MACH = (CFG.machines || []).map(Number), ADD = (CFG.addons || []).map(Number), MIN = Number(CFG.min || 0) * 100;
  var guarding = false;
  var SHIP = Number(CFG.ship || 0), OPTS = CFG.opts || [];
  var ICO = {
    shield: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    bolt: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2.5L4.5 13.5H11l-1 8 8.5-11H12z"/></svg>'
  };
  function hasMain(c) { return c.items.some(function (it) { return MACH.indexOf(it.product_id) > -1; }); }
  /* options proposées dans le panier (décochées tant que le client ne les ajoute pas) */
  function renderOpts(c) {
    var box = $('[data-sb-opts]'); if (!box) return;
    if (!OPTS.length || !hasMain(c)) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    box.innerHTML = '<p class="sb-ct__oh">' + esc(T.opts) + '</p>' + OPTS.map(function (o) {
      var line = c.items.filter(function (it) { return it.variant_id === o.id; })[0];
      return '<label class="tb-opt tb-opt--ct"><input type="checkbox" data-sb-opt="' + o.id + '"' + (line ? ' checked data-key="' + esc(line.key) + '"' : '') + '>' +
        '<span class="tb-opt__sw" aria-hidden="true"><i></i></span><span class="tb-opt__ic">' + (ICO[o.ic] || '') + '</span>' +
        '<span class="tb-opt__t"><b>' + esc(o.t) + '</b><small>' + esc(o.p) + '</small></span><span class="tb-opt__p">+' + money(o.price) + '</span></label>';
    }).join('');
  }
  /* anti commande test : sans calendrier dans le panier, la protection et l'expédition prioritaire partent aussi */
  function guard(c) {
    if (guarding || !MACH.length) return null;
    var has = c.items.some(function (it) { return MACH.indexOf(it.product_id) > -1; });
    var orphans = c.items.filter(function (it) { return ADD.indexOf(it.product_id) > -1; });
    if (has || !orphans.length) return null;
    guarding = true;
    var upd = {}; orphans.forEach(function (it) { upd[it.key] = 0; });
    return fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: upd })
    }).then(function (r) { return r.json(); }).then(function (c2) { guarding = false; render(c2); return c2; })
      .catch(function () { guarding = false; });
  }
  function under(c) { return (MIN > 0 && c.total_price < MIN) || (MACH.length > 0 && !hasMain(c)); }
  var lastCart = null;
  function render(c) {
    if (guard(c)) return;
    lastCart = c;
    $$('[data-sb-count]').forEach(function (n) { n.textContent = c.item_count; n.hidden = !c.item_count; });
    var box = $('[data-sb-lines]'), foot = $('[data-sb-foot]');
    if (!box) return;
    if (!c.item_count) {
      tmStop();
      box.innerHTML = '<div class="sb-ct__empty">' + (expired ? '<p class="sb-ct__exp">' + esc(T.tmx) + '</p>' : '') + '<p>' + esc(T.empty) + '</p><button type="button" class="sb-btn sb-btn--sm" data-sb-close>' + esc(T.keep) + '</button></div>';
      if (foot) foot.hidden = true;
      renderOpts(c);
      return;
    }
    if (TMIN > 0) { if (!lsGet()) lsSet(Date.now() + TMIN * 60000); if (!tmI) tmRun(); }
    var rows = c.items.slice().sort(function (x, y) { return (ADD.indexOf(x.product_id) > -1) - (ADD.indexOf(y.product_id) > -1); });
    box.innerHTML = rows.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var free = it.final_line_price === 0;
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var opt = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
      var isAdd = ADD.indexOf(it.product_id) > -1;
      var ico = ADD.indexOf(it.product_id) === 1 ? ICO.bolt : ICO.shield;
      var qty = isAdd ? '' : '<span class="sb-qty sb-qty--sm"><button type="button" data-sb-q="' + (it.quantity - 1) + '" aria-label="' + esc(T.minus) + '">−</button><span aria-label="' + esc(T.qty) + '">' + it.quantity + '</span><button type="button" data-sb-q="' + (it.quantity + 1) + '" aria-label="' + esc(T.plus) + '">+</button></span>';
      return '<div class="sb-li" data-key="' + esc(it.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="sb-li__ph">' + (isAdd ? ico : '') + '</span>') +
        '<div class="sb-li__t"><b>' + esc(it.product_title) + '</b>' + opt + qty +
        '</div>' +
        '<div class="sb-li__p">' + was + '<b' + (free ? ' class="sb-ok"' : '') + '>' + (free ? esc(T.free) : money(it.final_line_price)) + '</b>' +
          '<button type="button" class="sb-li__rm" data-sb-q="0" aria-label="' + esc(T.remove) + '">' + esc(T.remove) + '</button></div>' +
      '</div>';
    }).join('');
    var disc = c.original_total_price - c.total_price;
    if (foot) {
      foot.hidden = false;
      $('[data-sb-sub]', foot).textContent = money(c.original_total_price);
      $('[data-sb-disc-row]', foot).hidden = !(disc > 0);
      $('[data-sb-disc]', foot).textContent = '−' + money(disc);
      var eur = !CFG.cur || CFG.cur === 'EUR' || c.currency === CFG.cur;
      var sh = $('[data-sb-ship]', foot); if (sh) sh.textContent = SHIP && eur ? money(SHIP) : T.calc;
      $('[data-sb-tot]', foot).textContent = money(c.total_price + (SHIP && eur ? SHIP : 0));
      var lock = under(c), mm = $('[data-sb-min]', foot), go = $('[data-sb-go]', foot);
      if (mm) { mm.hidden = !lock; mm.textContent = (T.min || '').replace('{min}', money(MIN)) + ' ' + (T.min_more || '').replace('{x}', money(MIN - c.total_price)); }
      if (go) { go.classList.toggle('is-locked', lock); go.setAttribute('aria-disabled', String(lock)); }
    }
    renderOpts(c);
  }
  /* minuteur du panier : démarre au premier ajout ; à zéro, le panier est vraiment vidé */
  var TMIN = Number(CFG.timer || 0), TKEY = 'bz_cart_exp', tmEl = $('[data-sb-tm]'), tmT = $('[data-sb-tmt]'), tmB = $('[data-sb-tmb]'), tmI = null, expired = false;
  var lsGet = function () { try { return Number(localStorage.getItem(TKEY)) || 0; } catch (e) { return 0; } };
  var lsSet = function (v) { try { if (v) localStorage.setItem(TKEY, String(v)); else localStorage.removeItem(TKEY); } catch (e) {} };
  function tmStart() { if (TMIN > 0 && lsGet() < Date.now()) lsSet(Date.now() + TMIN * 60000); expired = false; tmRun(); }
  function tmStop() { lsSet(0); clearInterval(tmI); tmI = null; if (tmEl) tmEl.hidden = true; if (tmB) tmB.hidden = true; }
  function tmTick() {
    var end = lsGet(), left = Math.ceil((end - Date.now()) / 1000);
    if (!end) { tmStop(); return; }
    if (left <= 0) {
      tmStop(); expired = true;
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).then(function () { return refresh(); });
      return;
    }
    var t = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0');
    if (tmEl) { tmEl.hidden = false; tmEl.classList.toggle('is-low', left <= 60); tmT.innerHTML = esc(T.tm || '').replace('{t}', '<b>' + t + '</b>'); }
    if (tmB) { tmB.hidden = false; tmB.textContent = t; }
  }
  function tmRun() { if (TMIN <= 0) return; clearInterval(tmI); tmTick(); if (lsGet()) tmI = setInterval(tmTick, 1000); }

  function refresh() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
  function open() { show(cartEl); return refresh(); }

  var SB = window.SB = {
    t: T, money: money, refresh: refresh, open: open,
    add: function (items) {
      items = (items || []).filter(function (x) { return x && x.id; });
      return fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }).then(function () { bump(); tmStart(); return open(); });
    }
  };
  /* délais de livraison (ouverture de la boutique) : prise en compte + traitement, puis livraison en jours ouvrés */
  var ETA = CFG.eta || {};
  function addBiz(d, n) { d = new Date(d); var k = 0; while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; } return d; }
  function etaRange(prio, from) {
    var s0 = from ? new Date(from) : new Date(); s0.setDate(s0.getDate() + Number(ETA.p1 || 7));
    var shipA = addBiz(s0, 1), shipB = addBiz(s0, Number(ETA.p2 || 2));
    return { shipA: shipA, shipB: shipB, a: addBiz(shipA, Number(ETA.b1 || 3)), b: addBiz(shipB, prio ? Number(ETA.b2p || 10) : Number(ETA.b2 || 15)) };
  }
  /* dernier jour de commande pour être livré au plus tard à une date donnée (délai maximum) */
  function etaCutoff(ts, prio) { var d = new Date(ts); for (var i = 0; i < 120; i++) { d.setDate(d.getDate() - 1); if (etaRange(prio, d).b.getTime() <= ts) return d; } return null; }
  SB.eta = etaRange; SB.cutoff = etaCutoff;

  /* petit rebond de l'icône panier après un ajout */
  function bump() {
    $$('.sb-hd__cart, [data-sb-count]').forEach(function (el) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
  }

  document.addEventListener('click', function (e) {
    /* commande minimum : aucun passage au paiement sous le montant minimum, ni sans machine */
    var ck = e.target.closest('a[href$="/checkout"], [name="checkout"]');
    if (ck && lastCart && (under(lastCart) || !lastCart.items.some(function (it) { return MACH.indexOf(it.product_id) > -1; }))) {
      e.preventDefault(); open(); var mm = $('[data-sb-min]'); if (mm) { mm.hidden = false; mm.classList.remove('is-shake'); void mm.offsetWidth; mm.classList.add('is-shake'); }
      return;
    }
    if (e.target.closest('[data-sb-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-sb-close]')) { e.preventDefault(); hide(cartEl); return; }
    if (e.target.closest('[data-sb-menu]')) { e.preventDefault(); burger.setAttribute('aria-expanded', 'true'); show(drawer); return; }
    var mc = e.target.closest('[data-sb-menu-close]');
    if (mc) { if (mc.tagName !== 'A') e.preventDefault(); if (burger) burger.setAttribute('aria-expanded', 'false'); hide(drawer); return; }
    var q = e.target.closest('[data-sb-q]');
    if (q) {
      e.preventDefault();
      var li = q.closest('.sb-li'); if (li) li.classList.add('is-busy');
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: li.getAttribute('data-key'), quantity: Math.max(0, Number(q.getAttribute('data-sb-q')) || 0) })
      }).then(function (r) { return r.json(); }).then(render).catch(refresh);
    }
  });
  document.addEventListener('change', function (e) {
    var o = e.target.closest('[data-sb-opt]'); if (!o) return;
    var lbl = o.closest('.tb-opt'); if (lbl) lbl.classList.add('is-busy');
    var req = o.checked
      ? fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(o.getAttribute('data-sb-opt')), quantity: 1 }] }) })
      : fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: o.getAttribute('data-key'), quantity: 0 }) });
    req.then(function () { bump(); return refresh(); }).catch(refresh);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(cartEl); hide(drawer); } });
  document.addEventListener('change', function (e) { var s = e.target.closest('[data-sb-loc]'); if (s) s.form.submit(); });

  /* en-tête : ombre une fois la page défilée */
  var hd = $('[data-sb-hd]');
  var onScroll = function () { var w = $('.page-wrapper'); var y = (w && w.scrollTop) || window.scrollY || 0; if (hd) hd.classList.toggle('is-stuck', y > 10); };
  window.addEventListener('scroll', onScroll, { passive: true });
  var pw = $('.page-wrapper'); if (pw) pw.addEventListener('scroll', onScroll, { passive: true });

  /* le bandeau défilant part avec le défilement, l'en-tête reste collé */
  var tk = $('.sb-tk');
  var bars = function () { document.documentElement.style.setProperty('--sb-tk', (tk ? tk.offsetHeight : 0) + 'px'); };
  bars(); window.addEventListener('resize', bars);

  /* effet d'onde au clic sur les boutons, packs et options */
  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest('.sb-btn, .tb-opt');
    if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = el.getBoundingClientRect(), s = Math.max(r.width, r.height);
    var w = document.createElement('span'); w.className = 'sb-ripple';
    w.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + (e.clientX - r.left - s / 2) + 'px;top:' + (e.clientY - r.top - s / 2) + 'px';
    el.appendChild(w); setTimeout(function () { w.remove(); }, 650);
  });

  /* la page /cart ouvre le panier latéral (un seul panier, avec ses règles) */
  if (/\/cart\/?$/.test(location.pathname)) { location.replace(root + '?panier=1'); return; }
  if (/[?&]panier=1/.test(location.search)) setTimeout(open, 300);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
